import styled from 'styled-components';
import { PillButton, GhostButtonComponent, PrimaryButtonComponent } from "../../../../../../CommonComponents/commonStyles";
import { Divider, Button } from 'antd';

export const MainHead = styled.div`
    font-family: BerkeleyStd-Book;
    font-size: 32px;
    letter-spacing: 0.5px;
    color: #022737;
    margin-bottom: ${props  => props.marginBottom};
    margin-top: ${props  => props.marginTop};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: ${props => props.mB};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
    }
`
export const MainHeading = styled.h1`
    font-family: BerkeleyStd-Book;
    font-size: 32px;
    letter-spacing: 0.5px;
    color: #022737;
    margin-bottom: ${props  => props.marginBottom};
    margin-top: ${props  => props.marginTop};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: ${props => props.mB};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
    }
`
export const Bold = styled.span`
    font-family: HelveticaNeue-Bold;
`

export const Content = styled.div`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #505050;
    margin-bottom: ${props => props.marginBottom};
    padding-bottom: ${props => props.paddingBottom};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: 14px;
        margin-bottom: ${props => props.mB};
    }
`

export const SubHead = styled.div`
     font-family: BerkeleyStd-Medium;
    font-size: 24px;
    letter-spacing: 0.7px;
    color: #022737;
    margin-bottom: ${props => props.marginBottom};
`

export const PillButtonComponent = styled(Button)`
    margin-bottom: ${props => props.marginBottom};
    color: #006778;
    font-size: 14px;
    font-family: HelveticaNeue-Medium;
    background-color: #f5f5f5;
    border-radius: 18px;
    box-shadow: 0;
    &:hover, &:focus{
        color: #006778;
        border: 1px solid #d4d4d4;
        background-color: #f5f5f5;
    }
`

export const DividerComponent = styled(Divider)`
    &&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: 50px;
     margin-bottom: 50px;
     background: #d4d4d4;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
&&&
.ant-divider, 
  .ant-divider-horizontal{
    margin-top: 40px;
     margin-bottom: 40px;
     background: #d4d4d4;
}
}
`;

export const DividerWrap = styled.div`
    padding-bottom: ${props => props.paddingBottom}
`;

export const DisplayflexMain = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Displayflex = styled.div`
    display: flex;
`;

export const TypeValue = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
color: ${props => props.theme.fontColors.textColor};
`;
